import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../Services/auth';

@Injectable({ providedIn: 'root' })
export class RedirectIfLoggedInGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    try {
      if (this.authService && this.authService.isLoggedIn && this.authService.isLoggedIn()) {
        // If logged in, redirect to dashboard
        return this.router.createUrlTree(['/dashboard']);
      }
    } catch (e) {
      console.warn('RedirectIfLoggedInGuard check failed', e);
    }
    return true;
  }
}
